import { render, staticRenderFns } from "./SmallDisplayList.vue?vue&type=template&id=b666f090&scoped=true"
import script from "./SmallDisplayList.vue?vue&type=script&lang=js"
export * from "./SmallDisplayList.vue?vue&type=script&lang=js"
import style0 from "./SmallDisplayList.vue?vue&type=style&index=0&id=b666f090&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b666f090",
  null
  
)

export default component.exports